"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Collection = /** @class */function () {
  function Collection() {
    this._items = [];
  }
  Collection.prototype.get = function (index) {
    return this._items[index];
  };
  Collection.prototype.add = function (item) {
    this._items.push(item);
    if (this.onItemAdded) {
      this.onItemAdded(item);
    }
  };
  Collection.prototype.remove = function (item) {
    var i = this._items.indexOf(item);
    if (i >= 0) {
      this._items = this._items.splice(i, 1);
      if (this.onItemRemoved) {
        this.onItemRemoved(item);
      }
    }
  };
  Collection.prototype.indexOf = function (item) {
    return this._items.indexOf(item);
  };
  Object.defineProperty(Collection.prototype, "length", {
    get: function () {
      return this._items.length;
    },
    enumerable: false,
    configurable: true
  });
  return Collection;
}();
exports.Collection = Collection;